import React from 'react';
import { Alert } from '@mui/material';

const SafetyWarning = () => {
  return (
    <Alert
      severity="warning"
      sx={{
        mt: 1.5,
        mb: 0.5,
        py: 0.5,
        px: 1.5,
        borderRadius: 2,
        '& .MuiAlert-icon': {
          fontSize: '1.1rem',
          mr: 1,
          mt: '2px'
        },
        '& .MuiAlert-message': {
          fontSize: '0.75rem',
          lineHeight: 1.4,
          padding: '2px 0'
        }
      }}
    >
      <strong>Safety Notice:</strong> Always consult a qualified healthcare or fitness professional before participating in any physical activity. AI recommendations are not a substitute for professional or medical advice, and may not be accurate for your individual needs.
    </Alert>
  );
};

export default SafetyWarning;